<template>
  <div v-if="filters && filters.length" class="input_filter_container is-align-items-center is-flex">
      <div v-for="filter in filters" :key="filter.designator">
        <component
          v-if="filter.component"
          :is="filter.component"
          :ref="filter.component"
          @select="(r) => customSelect(filter, r)"
          anchor="input_filters"
          class="input_horizontal_space"
        ></component>
        <input
          v-else
          v-model="data[filter.designator]"
          class="outlined input_horizontal_space input_placeholder"
          :class="filter.class"
          :placeholder="`${filter.customPlaceholder || ('Search by ' + (filter.placeholder || filter.designator))}`"
        >
      </div>
      <a @click="submit(false)" class="filter button is-info">Search</a>
      <div class="horizontal_space"></div>
      <a v-if="$route.meta.isPositionOffers" @click="submit(true, false)" class="filter button is-danger">Search and ignore filters</a>
      <div class="horizontal_space"></div>
      <p v-if="$route.query.company_name">SHOWING RESULTS FOR COMPANY <b>"{{ $route.query.company_name }}"</b></p>
  </div>
</template>
<script>
import SearchCompanies from '@/components/SearchCompanies.vue'
export default {
  name: 'filters-input',
  components: {
    SearchCompanies
  },
  props: ['filters'],
  data () {
    return {
      data: {}
    }
  },
  computed: {
    queryParams () {
      if (this.$route.name === 'applicant-offers') {
        return {
          applicant_id: this.$route.query.applicant_id, sort: this.$route.query.sort, is_hot_positions: 'true'
        }
      }
      if (this.$route.name === 'position-offers') {
        return {
          company_id: this.$route.query.company_id, position_id: this.$route.query.position_id, sort: this.$route.query.sort
        }
      }
      return {}
    }
  },
  created () {
    this.filters.forEach(filter => {
      this.$set(this.data, filter.designator, this.$route.query[filter.designator])
    })
  },
  methods: {
    customSelect (filter, result) {
      this.data[filter.designator] = result.name
    },
    submit (ignore, isHot) {
      const isHotPosition = isHot ? 'true' : undefined
      let query = ignore ? this.queryParams : { ...this.$route.query, is_hot_positions: isHotPosition }
      Object.entries(this.data).forEach(entry => {
        query[entry[0]] = entry[1]
      })
      this.$router.push({ path: this.$route.path, query: query })
    }
  }
}
</script>
<style scoped>
.input_filter_container {
  margin: 15px 0 15px 30px;
}
.input_horizontal_space {
  margin-right: 10px;
}
.input_placeholder::placeholder {
  color: #666;
  opacity: 1; /* Firefox */
}
.input_placeholder:-ms-input-placeholder { /* Internet Explorer 10-11 */
 color: #666;
}
.input_placeholder::-ms-input-placeholder { /* Microsoft Edge */
 color: #666;
}
</style>
